import {useState} from 'react';
import {api} from '../../services/api';
import type {Identity} from '../../types';

export type LoginHostMode='tenant'|'development';

export function Login({
 onLogin,
 mode='development',
 tenantName,
}:{
 onLogin:(identity:Identity)=>void;
 mode?:LoginHostMode;
 tenantName?:string;
}){
 const [error,setError]=useState(''),[pending,setPending]=useState(false);
 const tenantBound=mode==='tenant';
 return (
  <main className="login-wrap">
   <section className="login-panel">
    <div className="login-brand">eSaaS<span>.app</span></div>
    <h1>Sign in to your workspace</h1>
    <p>{tenantBound&&tenantName?tenantName:'Accounts & Grey Conversion ERP'}</p>
    <form onSubmit={async e=>{
     e.preventDefault();
     if(pending)return;
     const data=new FormData(e.currentTarget);
     const body:Record<string,string>={
      username:String(data.get('username')||'').trim(),
      password:String(data.get('password')||''),
     };
     if(!tenantBound)body.tenant=String(data.get('tenant')||'');
     setPending(true);setError('');
     try{onLogin(await api<Identity>('/auth/login',{method:'POST',body:JSON.stringify(body)}))}
     catch(err){setError(err instanceof Error?err.message:'Sign in failed')}
     finally{setPending(false)}
    }}>
     {!tenantBound&&<label>Tenant<input name="tenant" autoComplete="organization" required/></label>}
     <label>Username<input name="username" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false} required/></label>
     <label>Password<input name="password" type="password" autoComplete="current-password" required/></label>
     <p role="alert">{error}</p>
     <button className="primary" disabled={pending}>{pending?'Signing in…':'Sign in'}</button>
    </form>
    <p className="muted">{tenantBound?'Financial posting requires workspace activation':'Sign in to your workspace'}</p>
   </section>
  </main>
 );
}
